export default "__VITE_ASSET__6tty052n__"